/**
 * An error indicating that the entity was not found
 */
export class ErrorNotFound extends Error {
}
/**
 * An error indicating that the entity was found but you do not have access rights
 */
export class ErrorForbidden extends Error {
}
/**
 * An error indicating that user is not authenticated
 */
export class ErrorNotAuthenticated extends Error {
}
